import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import {CardActions} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Grid from "@material-ui/core/Grid";
import {anularTagsResources} from "../endpoints";
import useToken from "../useToken";

class AnularTags extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            anular: true,
            motivos: [],
            motivo: null,
            comentario:"",
        }
    }

    obtenerMotivos =()=>{
        anularTagsResources.getMotivosAnular().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({motivos:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    handleClick = () =>{
        this.user = useToken.getUser();
        const datosAnularTag={
            tags: this.props.tags,
            usuario: this.user.id_usuario,
            id_tag_nulo_motivo: this.state.motivo.id,
            comentario: this.state.comentario
        }
        anularTagsResources.agregarTagNulo(datosAnularTag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
            console.log(error)
        });

    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            this.handleClick()
        }
        else if(event.keyCode === 27){
            this.props.handleClose()
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    componentDidMount() {
        this.obtenerMotivos()
        document.addEventListener('keyup', this.getEventType, false);    // third
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    render() {
        return (
            <div>
                <Modal
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'}}
                    disableAutoFocus={true}
                    open={this.state.anular}>
                    <Card style={{width:600}}>
                        <CardContent style={{margin:2}}>
                            <Typography variant={"h6"} style={{marginBottom:4}}>Anular Tag/s</Typography>
                            <Grid container spacing={2} alignItems="flex-end">
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="size-small-standard"
                                        onChange={(event, newValue) => {this.setState({motivo: newValue})}}
                                        size="small"
                                        options={this.state.motivos}
                                        noOptionsText={"No hay opciones"}
                                        getOptionLabel={(option) => option.descripcion || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="standard" label="Motivos" placeholder="Disponibles" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Comentarios"
                                        onChange={this.handleChange}
                                        value={this.state.comentario}
                                        name="comentario"
                                        fullWidth
                                        multiline
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions style={{justifyContent: "end"}}>
                            <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                                Cancelar
                            </Button>
                            <Button disabled={!this.state.motivo} variant="contained" color="primary" onClick={this.handleClick}>
                                Guardar</Button>
                        </CardActions>
                    </Card>
                </Modal>
            </div>
        );
    }
}

export default AnularTags;